import { useFela } from 'react-fela';

import { getInitials } from './getInitials';
import * as felaRules from './UserAvatar.rules';

export interface UserAvatarProps {
    name: string;
    pictureUrl?: string;
    size?: number;
    className?: string;
}

export const UserAvatar = ({ name, pictureUrl, size = 40, className }: UserAvatarProps) => {
    const { css } = useFela({ size });

    if (pictureUrl) {
        return (
            <span className={css(felaRules.container, className)}>
                <img className={css(felaRules.image)} src={pictureUrl} alt={name} />
            </span>
        );
    }

    return (
        <span className={css(felaRules.container, className)} role='img' aria-label={name}>
            <span className={css(felaRules.initials)} aria-hidden>
                {getInitials(name)}
            </span>
        </span>
    );
};
